import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'toCurrencyString' })
export class ToCurrencyStringPipe implements PipeTransform {
  transform(value: number, currency: string, country: string, decimalPlaces = 0): any {
    
    if (value == null || value === undefined || value.toFixed === undefined)  {
      return (0).toFixed(decimalPlaces).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } 

  
    if(value.toString().includes("15")){
 
    }

    if (country == "ES" && currency == "EUR") {
      return value.toLocaleString("es-ES", { minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces });
    }
    if (currency == "EUR") {
      return value.toLocaleString("es-ES", { minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces });
    }
    else {

      return value.toFixed(decimalPlaces).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
    // return value.toLocaleString();
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/currencyToString.pipe.ts